
import React from 'react';
import { 
  LineChart, 
  Line, 
  XAxis, 
  YAxis, 
  Tooltip, 
  ResponsiveContainer,
  ReferenceLine,
  Area,
  ComposedChart
} from 'recharts';

interface BloodSugarChartProps {
  bloodSugarData: Array<{ hour: number; value: number }>;
  hoursElapsed: number;
}

export const BloodSugarChart: React.FC<BloodSugarChartProps> = ({ 
  bloodSugarData,
  hoursElapsed
}) => {
  return (
    <div className="h-48">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={bloodSugarData}>
          <defs>
            <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#0EA5E9" stopOpacity={0.3}/>
              <stop offset="95%" stopColor="#0EA5E9" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <XAxis 
            dataKey="hour" 
            tick={{fontSize: 12}} 
            label={{ value: 'Hours', position: 'insideBottomRight', offset: 0 }}
          />
          <YAxis 
            domain={[60, 140]} 
            tick={{fontSize: 12}}
            label={{ value: 'mg/dL', angle: -90, position: 'insideLeft' }}
          />
          <Tooltip 
            formatter={(value) => [`${value} mg/dL`, 'Blood Sugar']}
            labelFormatter={(label) => `Hour ${label}`}
          />
          <ReferenceLine y={70} stroke="#f97316" strokeDasharray="3 3" />
          <Area
            type="monotone"
            dataKey="value"
            stroke="#0EA5E9"
            fillOpacity={1}
            fill="url(#colorValue)"
          />
          <Line 
            type="monotone" 
            dataKey="value" 
            stroke="#0EA5E9" 
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 6, fill: "#0EA5E9", stroke: "#fff" }}
          />
          <ReferenceLine 
            x={hoursElapsed} 
            stroke="#8B5CF6" 
            label={{ value: 'Now', position: 'top', fill: '#8B5CF6' }}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};
